import { createSlice } from '@reduxjs/toolkit';

interface BraintreeState {
  braintreeClientToken: string;
  isBraintreeUiLoading: boolean;
  isBraintreeError: boolean;
  errorMessage: string;
  consentGiven?: boolean;
}

const initialState: BraintreeState = {
  braintreeClientToken: '',
  isBraintreeUiLoading: false,
  isBraintreeError: false,
  errorMessage: '',
  consentGiven: false,
};

const braintreeSlice = createSlice({
  name: 'braintree',
  initialState,
  reducers: {
    fetchBraintreeRequest: (state) => {
      state.isBraintreeUiLoading = true;
      state.isBraintreeError = false;
      state.errorMessage = '';
    },
    fetchBraintreeSuccess: (state, action) => {
      state.isBraintreeUiLoading = false;
      state.braintreeClientToken = action.payload;
      state.isBraintreeError = false;
    },
    fetchBraintreeFailure: (state, action) => {
      state.isBraintreeUiLoading = false;
      state.isBraintreeError = true;
      state.errorMessage = action.payload;
      state.braintreeClientToken = '';
    },
    setConsentGiven: (state, action) => {
      state.consentGiven = action.payload;
    },
  },
});

export const {
  fetchBraintreeRequest,
  fetchBraintreeSuccess,
  fetchBraintreeFailure,
  setConsentGiven,
} = braintreeSlice.actions;

export default braintreeSlice.reducer;
